import { cn } from '@heidi/utils';

// Deep import, not the `../typography` door: ~300 app tests partially mock
// `@heidi/design-system/typography`, and a factory omitting `typographyVariant`
// would leave it `undefined` here. The door is the mock target; the leaf is not.
import { typographyVariant } from '../typography/typography.styles';

/**
 * Text roles of a form field group, behind
 * `release-experimental-design-system-forms`. Shared by Label, the Combobox
 * error message, and the `Form` family
 */

/** Field title — 14/500, the only bold text in a field group. */
export const formFieldTitleText = cn(
  typographyVariant({ variant: 'p2Bold' }),
  'text-text-primary'
);

/** Description and help text — the title's size at 400. */
export const formFieldDescriptionText = cn(
  typographyVariant({ variant: 'p2' }),
  'text-text-secondary',
  'text-pretty'
);

/** Error and validation text — the description recipe in the destructive tint. */
export const formFieldErrorText = cn(
  typographyVariant({ variant: 'p2' }),
  'text-semantic-text-destructive',
  'text-pretty'
);
